import React, { useState, useEffect } from 'react'
import { Checkbox, Pane, Text, Button, ComparisonIcon, TickCircleIcon, ArrowRightIcon } from 'evergreen-ui'
import { ServiceOption } from './ServiceOption'
import { FoldingWizard } from './FoldingWizard'
import { PaintingWizard } from './PaintingWizard'
import { useAPI } from '../../Api'
import { AttachFiles } from '../../Misc/AttachFiles'
import { BookAttachments } from '../../Misc/BookAttachments'

import { SelMaterial } from './SelMaterial'

import { Icons, PageControl } from '../../Misc'



export function Services(props) {
    // console.log("In Services: ", props.order);
    let API = useAPI();
    const [mode, setMode] = React.useState(0);
    useEffect(() => {
        props.setIds([])
    }, [mode]);

    let setColor = (color) => {
        let o = props.order;
        o.color = color;
        props.setOrder({ ...o })
    }

    let isAdmin = API.isAdmin;

    return (
        <PageControl page={mode} display={'flex'} >
            <Pane padding={20} height="100%" overflow="scroll" display={"flex"} justifyContent={"center"} alignItems={"center"} flexDirection={"column"}>
                <Button marginBottom={"20px"} elevation={2} padding={20} width="fit-content" onClick={()=>{ props.setPage(3)}}>
                    {props.order && <SelMaterial selMaterial={props.order.selMaterial} fontSize={18} />}
                </Button>
                {(props.order.bends && props.order.bends.length  > 0) && <Text fontSize={24}>Select services to add to your design</Text>}
                {props.order.bends && props.order.bends.length > 0 ?
                    <Button
                        intent="success"
                        style={{ marginTop: "10px" }}
                        width="100%"
                        iconBefore={Icons.folding[0]}
                        onClick={e => { setMode(1) }}
                        size="large"
                    >Folding   {props.order.bends && props.order.bends.filter((v) => v != null).length > 0 &&

                        <Text marginLeft={16} textAlign="center">Folds: {props.order.bends.filter((v) => v != null).length}</Text>

                        }
                    </Button> : <Button
                        style={{ marginTop: "10px" }}
                        width="100%"
                        iconBefore={Icons.folding[0]}
                        size="large"
                    >No Folds Found
                    </Button>}

                <BookAttachments book={props.order.book} />

                {isAdmin &&
                    <Pane  marginTop={'2em'} display="flex" justifyContent="center">
                        <Pane border={"1px solid red"} borderRadius={"10px"} padding={"10px"} height={"fit-content"}>
                            <Text>Cutting Length: {props.order.cuttingLength?.toFixed(2)} mm</Text>
                        </Pane>
                    </Pane>
                }

                {/* <ServiceOption checked={props.order.gluing} option="Gluing" key="Gluing" iconBefore={Icons.gluing[props.order.gluing ? 1 : 0]} onClick={() => {
                    let o = props.order;
                    o.gluing = !o.gluing;
                    props.setOrder({ ...o })
                }} /> */}
                {/* 
                <ServiceOption checked={props.order.welding} option="Welding" key="Welding" iconBefore={Icons.welding[0]} onClick={() => {
                    let o = props.order;
                    o.welding = !o.welding;
                    props.setOrder({ ...o })
                }} /> */}


                {/* <Button
                    intent="success"
                    style={{ marginTop: "10px" }}
                    width="100%"
                    iconBefore={Icons.painting[0]}
                    onClick={e => { setMode(2) }}
                    size="large"
                >Painting {props.order.color && <Text marginLeft={16}>{props.order.color}</Text>}
                </Button> */}

                {/* 
                <ServiceOption checked={props.order.color} onCancel={() => { setColor(null) }} iconBefore={Icons.painting[0]} canConfirm={props.order.color || props.order.color == null} option="Painting" key="Painting">
                    <PaintingWizard
                        setColor={setColor}
                        getColor={props.order.color}
                        paintColours={props.paintColours}
                    />
                </ServiceOption> */}


                {/* <ServiceOption checked={props.order.assembly} option="Assembly" key="Assembly" iconBefore={Icons.assembly[0]} onClick={() => {
                    let o = props.order;
                    o.assembly = !o.assembly;
                    props.setOrder({ ...o })
                }} /> */}

            </Pane>

            <Pane padding={50} >
                <FoldingWizard {...props} />

                <Button
                    style={{ marginTop: "10px" }}
                    width="100%"

                    onClick={e => { setMode(0) }}
                    size="large"
                >Save Folds
                </Button>
            </Pane>


            <Pane padding={20}>
                <PaintingWizard
                    setColor={(c) => { setColor(c); setMode(0) }}
                    getColor={props.order.color}
                />

                <Button
                    style={{ marginTop: "10px" }}
                    width="100%"

                    onClick={e => { setMode(0) }}
                    size="large"
                >Save
                </Button>
            </Pane>
        </PageControl>
    )

}
